import { render, staticRenderFns } from "./FinishStep.vue?vue&type=template&id=6ca39964&scoped=true"
import script from "./FinishStep.vue?vue&type=script&lang=js"
export * from "./FinishStep.vue?vue&type=script&lang=js"
import style0 from "./FinishStep.vue?vue&type=style&index=0&id=6ca39964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca39964",
  null
  
)

export default component.exports